<template>
<div class="row">

	<div class="col-12">

		<div class="row">
			<div class="col-md-12">
				<h1 class="display-4">Inbrengers</h1>
			</div>
		</div>

		<!-- Filter section -->
		<div class="mb-4 row">
			<div class="col-6">
				<general-input
					v-model="filters.code"
					label="Inbrengcode"
					placeholder="Zoek met inbrengcode"
				/>
			</div>

			<div class="col-6">
				<general-input
					v-model="filters.name"
					label="Naam"
					placeholder="Zoek op naam"
				/>
			</div>
		</div>

		<div class="row">
			<div class="col-12 d-flex justify-content-end">
				<b-pagination-nav :link-gen="linkGen"
				                  :number-of-pages="persons.last_page"
				                  :value="persons.current_page"
				                  use-router
				                  align="right" />
			</div>
		</div>

		<b-alert v-if="error"
		         variant="danger"
		         show>{{ error }}</b-alert>

		<partial-loader :loading="isFetching"></partial-loader>

		<b-table v-if="!isFetching"
				striped
				hover
				show-empty
				:items="persons.data"
				:fields="fields"
				:per-page="parseInt(persons.per_page)"
				:busy="isFetching"
				:empty-text="$t('seller.listEmptyText')"
				:empty-filtered-text="$t('seller.listEmptyFilteredText')"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:no-local-sorting="true"
		>

			<template v-slot:cell(actions)="row">
	 			<b-btn-group class="pull-right">
					<b-btn
						variant="outline-primary"
						:to="{ name: 'auctionSeller', params: { personId: row.item.id }, query: { back: 'auctionSellers' } }"
					>
						<i class="fa fa-fw fa-eye"></i>
					</b-btn>
					<b-btn
						variant="outline-primary"
						:to="{ name: 'itemList', query: { sellerId: row.item.id  } }"
					>
						<fa-icon icon="boxes">
						</fa-icon>
					</b-btn>
				</b-btn-group>
	 		</template>

			<template v-slot:cell(items)="row">
	 			{{ row.item.auction_items }}
	 		</template>

		</b-table>

		<b-pagination-nav :link-gen="linkGen"
		                  :number-of-pages="persons.last_page"
		                  :value="persons.current_page"
		                  use-router
		                  align="right" />
	</div>
</div>
</template>

<script>
import { isNil } from 'lodash';
import AuctionService from '@/services/auction-service.js';
import PartialLoader from '@/components/elements/PartialLoader';
import { isCancel, CancelToken } from 'axios';
import RequestHelper from '@/helpers/request-helper';
import GeneralInput from '../../../elements/Input/GeneralInput';

const requestHelper = new RequestHelper();

export default {
	components: {
		GeneralInput,
		PartialLoader
	},
	data() {
		return {
			isFetching: true,
			persons: {},
			error: null,
			fields: [
				{ key: 'code', label: this.$t('item.itemNumber',), sortable: true},
				{ key: 'full_name_simple', label: this.$t('common.name')},
				{ key: 'email', label: this.$t('common.email') },
				{ key: 'items', label: this.$t('seller.itemsInserted') },
				{ key: 'actions', label: this.$t('common.actions') },
			],
			currentPage: 1,
			perPage: 50,
			filter: '',
			sortBy: 'code',
			sortDesc: false,
			cancelToken: null,
			filters: {
				code: this.$route.query.code,
				name: this.$route.query.name,
			}
		}

	},
	watch: {
		'filters': {
			handler: function (val, oldVal) {
				this.filterData();
			},
			deep: true,
		},
		'$route': 'fetchData',
		'sortBy': 'filterData',
		'sortDesc': 'filterData'
	},
	methods: {
		initialize() {
			this.fetchData();
		},
		linkGen(pageNumber) {
			let queryString = this.$route.query;
			queryString.page = pageNumber;

			const URL = Object.keys(queryString).map(key => key + '=' + queryString[key]).join('&');

			return '?' + URL;
		},
		genUrl() {
			return `${this.genAuctionUrl()}/sellers?page=1&filter=${this.filter}`;
		},
		genAuctionUrl() {
			return `/auction/${this.$route.params.auctionId}`;
		},
		filterData() {
			this.$router.push({ query: {
				..._.pickBy(this.filters, _.identity),
			}}).catch(err => {});
		},
		fetchData() {
			this.error = null;
			this.isFetching = true;

			const query = this.$route.query;
			const currentPage = Number.parseInt(query.page);
			this.currentPage = isNaN(currentPage) ? 1 : currentPage;

			if (!isNil(this.cancelToken)) {
				this.cancelToken.cancel();
			}

			this.cancelToken = CancelToken.source();

			const sortBy = this.sortBy == 'code' ? 'number' : this.sortBy;

			const params = {
				total: this.perPage,
				page: this.currentPage,
				sort: sortBy,
				order: this.sortDesc ? 'desc' : 'asc',
				...query
			}

			return AuctionService.getAuctionSellers(this.$route.params.auctionId, params, this.cancelToken.token).then(response => {
				this.isFetching = false;
        		this.persons = response;
			}).catch(error => {
				if (!isCancel(error)) {
					this.isFetching = false;
					this.error = error.message;
				}
			});
		},
		setQuery() {
			if (this.$route.query.filter)
				this.filter = this.$route.query.filter;
		}
	},
	mounted() {
		this.setQuery();
		this.initialize();
	}
}
</script>



// WEBPACK FOOTER //
// SellerList.vue?62d7df86